import React, { useState, useEffect } from "react"
import "./EditManageStaff.scss"
import { useHistory, useLocation } from "react-router"
import { useSelector } from "react-redux"
import InputField from "../../../../components/InputField"
import Button from "../../../../components/Button"
import Dropdown from "components/DropDown"
import moment from 'moment'
import { addNewAvailability, getAllCenters, getAvailabilityDetails, getManageStaffDetailsById, updateAvailability } from "core/services/api"
import { MocUserRole } from "core/services/models/Enums"
import Toast from "components/Toast"

export default function StaffAvailability() {
  const history = useHistory()
  const location: any = useLocation()
  const id = location?.state?.idValue
  let readOnly = useSelector((state: any) => state?.user?.readOnly);
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const slotDuration: string[] = [
    "Morning Slot",
    "Afternoon Slot",
    "Evening Slot",
  ]

  const slots = {
    Monday: {
      mondayMorningStartTime: "",
      mondayMorningEndTime: "",
      mondayAfternoonStartTime: "",
      mondayAfternoonEndTime: "",
      mondayEveningStartTime: "",
      mondayEveningEndTime: "",
    },
    Tuesday: {
      tuesdayMorningStartTime: "",
      tuesdayMorningEndTime: "",
      tuesdayAfternoonStartTime: "",
      tuesdayAfternoonEndTime: "",
      tuesdayEveningStartTime: "",
      tuesdayEveningEndTime: "",
    },
    Wednesday: {
      wednesdayMorningStartTime: "",
      wednesdayMorningEndTime: "",
      wednesdayAfternoonStartTime: "",
      wednesdayAfternoonEndTime: "",
      wednesdayEveningStartTime: "",
      wednesdayEveningEndTime: "",
    },
    Thursday: {
      thursdayMorningStartTime: "",
      thursdayMorningEndTime: "",
      thursdayAfternoonStartTime: "",
      thursdayAfternoonEndTime: "",
      thursdayEveningStartTime: "",
      thursdayEveningEndTime: "",
    },
    Friday: {
      fridayMorningStartTime: "",
      fridayMorningEndTime: "",
      fridayAfternoonStartTime: "",
      fridayAfternoonEndTime: "",
      fridayEveningStartTime: "",
      fridayEveningEndTime: "",
    },

    Saturday: {
      saturdayMorningStartTime: "",
      saturdayMorningEndTime: "",
      saturdayAfternoonStartTime: "",
      saturdayAfternoonEndTime: "",
      saturdayEveningStartTime: "",
      saturdayEveningEndTime: "",
    },

    Sunday: {
      sundayMorningStartTime: "",
      sundayMorningEndTime: "",
      sundayAfternoonStartTime: "",
      sundayAfternoonEndTime: "",
      sundayEveningStartTime: "",
      sundayEveningEndTime: "",
    },
  }

  const defaultSlots = {
    Monday: {
      mondayMorningStartTime: "10:00",
      mondayMorningEndTime: "12:00",
      mondayAfternoonStartTime: "12:00",
      mondayAfternoonEndTime: "16:00",
      mondayEveningStartTime: "16:00",
      mondayEveningEndTime: "22:00",
    },
    Tuesday: {
      tuesdayMorningStartTime: "10:00",
      tuesdayMorningEndTime: "12:00",
      tuesdayAfternoonStartTime: "12:00",
      tuesdayAfternoonEndTime: "16:00",
      tuesdayEveningStartTime: "16:00",
      tuesdayEveningEndTime: "22:00",
    },
    Wednesday: {
      wednesdayMorningStartTime: "10:00",
      wednesdayMorningEndTime: "12:00",
      wednesdayAfternoonStartTime: "12:00",
      wednesdayAfternoonEndTime: "16:00",
      wednesdayEveningStartTime: "16:00",
      wednesdayEveningEndTime: "22:00",
    },
    Thursday: {
      thursdayMorningStartTime: "10:00",
      thursdayMorningEndTime: "12:00",
      thursdayAfternoonStartTime: "12:00",
      thursdayAfternoonEndTime: "16:00",
      thursdayEveningStartTime: "16:00",
      thursdayEveningEndTime: "22:00",
    },
    Friday: {
      fridayMorningStartTime: "10:00",
      fridayMorningEndTime: "12:00",
      fridayAfternoonStartTime: "12:00",
      fridayAfternoonEndTime: "16:00",
      fridayEveningStartTime: "16:00",
      fridayEveningEndTime: "22:00",
    },

    Saturday: {
      saturdayMorningStartTime: "10:00",
      saturdayMorningEndTime: "12:00",
      saturdayAfternoonStartTime: "12:00",
      saturdayAfternoonEndTime: "16:00",
      saturdayEveningStartTime: "16:00",
      saturdayEveningEndTime: "22:00",
    },

    Sunday: {
      sundayMorningStartTime: "10:00",
      sundayMorningEndTime: "12:00",
      sundayAfternoonStartTime: "12:00",
      sundayAfternoonEndTime: "16:00",
      sundayEveningStartTime: "16:00",
      sundayEveningEndTime: "22:00",
    },
  }

  const defaultSlotDescriptions: any = {
    mondayMorningStartTime: "Monday Morning Start Time",
    mondayMorningEndTime: "Monday Morning End Time",
    mondayAfternoonStartTime: "Monday Afternoon Start Time",
    mondayAfternoonEndTime: "Monday Afternoon End Time",
    mondayEveningStartTime: "Monday Evening Start Time",
    mondayEveningEndTime: "Monday Evening End Time",
    tuesdayMorningStartTime: "Tuesday Morning Start Time",
    tuesdayMorningEndTime: "Tuesday Morning End Time",
    tuesdayAfternoonStartTime: "Tuesday Afternoon Start Time",
    tuesdayAfternoonEndTime: "Tuesday Afternoon End Time",
    tuesdayEveningStartTime: "Tuesday Evening Start Time",
    tuesdayEveningEndTime: "Tuesday Evening End Time",
    wednesdayMorningStartTime: "Wednesday Morning Start Time",
    wednesdayMorningEndTime: "Wednesday Morning End Time",
    wednesdayAfternoonStartTime: "Wednesday Afternoon Start Time",
    wednesdayAfternoonEndTime: "Wednesday Afternoon End Time",
    wednesdayEveningStartTime: "Wednesday Evening Start Time",
    wednesdayEveningEndTime: "Wednesday Evening End Time",
    thursdayMorningStartTime: "Thursday Morning Start Time",
    thursdayMorningEndTime: "Thursday Morning End Time",
    thursdayAfternoonStartTime: "Thursday Afternoon Start Time",
    thursdayAfternoonEndTime: "Thursday Afternoon End Time",
    thursdayEveningStartTime: "Thursday Evening Start Time",
    thursdayEveningEndTime: "Thursday Evening End Time",
    fridayMorningStartTime: "Friday Morning Start Time",
    fridayMorningEndTime: "Friday Morning End Time",
    fridayAfternoonStartTime: "Friday Afternoon Start Time",
    fridayAfternoonEndTime: "Friday Afternoon End Time",
    fridayEveningStartTime: "Friday Evening Start Time",
    fridayEveningEndTime: "Friday Evening End Time",
    saturdayMorningStartTime: "Saturday Morning Start Time",
    saturdayMorningEndTime: "Saturday Morning End Time",
    saturdayAfternoonStartTime: "Saturday Afternoon Start Time",
    saturdayAfternoonEndTime: "Saturday Afternoon End Time",
    saturdayEveningStartTime: "Saturday Evening Start Time",
    saturdayEveningEndTime: "Saturday Evening End Time",
    sundayMorningStartTime: "Sunday Morning Start Time",
    sundayMorningEndTime: "Sunday Morning End Time",
    sundayAfternoonStartTime: "Sunday Afternoon Start Time",
    sundayAfternoonEndTime: "Sunday Afternoon End Time",
    sundayEveningStartTime: "Sunday Evening Start Time",
    sundayEveningEndTime: "Sunday Evening End Time",
  }

  const [staffDetails, setStaffDetails] = useState<any>({})
  const [allCenterDetails, setAllCenterDetails] = useState<any>([])
  const [staffCenterOptions, setStaffCenterOptions] = useState<any>([])
  const [selectedCenterDetails, setSelectedCenterDetails] = useState<any>({})
  const [allowed, setAllowed] = useState<any>([])
  const [availabilitySlots, setAvailabilitySlots] = useState<any>(slots)
  const [avaialbilityResult, setAvaialbilityResult] = useState<any>()
  const [hours, setHours] = useState('01')
  const [minutes, setMinutes] = useState('00')
  const [ampm, setAMPM] = useState('am')
  const [absenseListInfo, setAbsenseListInfo] = useState<any>({
    fromTime: "",
    toTime: "",
    absenseFromDate: "",
    absenseFromTime: "",
    absenseToDate: "",
    absenseToTime: "",
    remarks: "",
  })

  const [newAbsenseListInfo, setNewAbsenseListInfo] = useState<any>([])


  const [slotsRequired, setSlotsRequired] = useState<any>()
  const [success, setSuccess] = useState<boolean>(false)
  const [message, setMessage] = useState<string>("")
  const [toastType, setToastType] = useState<string>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [displayToast, toggleDisplayToast] = useState<any>(false)

  useEffect(() => {
    getAllCenterDetails()
    getStaffDetails()
    updateCenterDetails()
  }, [])

  useEffect(() => {
    getSlotDuration()
    fetchAvailabilityDetails()
  }, [selectedCenterDetails, staffDetails])

  const getStaffDetails = () => {
    if (id) {
      getManageStaffDetailsById(id)
        .then((res: any) => {
          const centersOptions = res?.centers?.map((each: any) => each?.centerName)
          const temp = res?.secondaryRoles?.map((ele: any) => ele)
          temp.push(res?.primaryRole)
          setAllowed(Array.isArray(temp) && temp?.length > 0 ? temp : [])
          setStaffCenterOptions(centersOptions)
          setStaffDetails(res)
        })
        .catch((err: any) => {
          console.log("Err,", err)
        })
    }
  }

  const getAllCenterDetails = () => {
    getAllCenters()
      .then((res: any) => {
        setAllCenterDetails(res)
      })
      .catch((err: any) => {
        console.log("Err,", err)
      })
  }

  const updateCenterDetails = () => {
    if (userRole === MocUserRole?.CENTER_ADMIN) {
      if (userDetail?.currentCenter && Object.keys(userDetail?.currentCenter)?.length > 0) {
        const tempCenter: any = {
          ...userDetail?.currentCenter
        }
        tempCenter["id"] = tempCenter?.centerId
        delete tempCenter["centerId"]
        setSelectedCenterDetails(tempCenter)
      }
    }
  }

  const fetchAvailabilityDetails = () => {
    if (staffDetails?.id && selectedCenterDetails?.id) {
      let centerId = selectedCenterDetails?.id
      getAvailabilityDetails(
        centerId,
        staffDetails?.id
      )
        .then((res) => {
          setAvaialbilityResult(res[0])
          if (res[0]?.availabilityTimeFrame) {
            if (Object.keys(res[0]?.availabilityTimeFrame).length > 0) {
              updateAvailabilitySlots(res[0]?.availabilityTimeFrame)
            }
          } else if (res?.length === 0) {
            setAvailabilitySlots(slots)
          }
          if (res[0]?.unavailability?.length > 0) {
            if (res[0]?.unavailability?.length > 0) {
              // if (
              //   res[0]?.unavailability[0]?.start &&
              //   res[0]?.unavailability[0]?.end &&
              //   res[0]?.unavailability[0]?.reason
              // ) {
              //   const startObj = res[0]?.unavailability[0]?.start?.split("T")
              //   const endObj = res[0]?.unavailability[0]?.end?.split("T")
              //   const temp = {
              //     absenseFromDate: startObj[0] ? startObj[0] : "",
              //     absenseFromTime: startObj[1] ? startObj[1] : "",
              //     absenseToDate: endObj[0] ? endObj[0] : "",
              //     absenseToTime: endObj[1] ? endObj[1] : "",
              //     remarks: res[0]?.unavailability[0]?.reason,
              //   }
              //   setAbsenseListInfo({ ...absenseListInfo, ...temp })
              // }

              setNewAbsenseListInfo([...res[0]?.unavailability])


            }
          }
        })
        .catch((err) => {
          console.log("Err", err)
        })
    }
  }

  const updateAvailabilitySlots = (slotsObj: any) => {
    //Monday
    const mondayMorningObj = slotsObj?.MONDAY_MORNING?.split("-")
    const mondayAfternoonObj = slotsObj?.MONDAY_AFTERNOON?.split("-")
    const mondayEveningObj = slotsObj?.MONDAY_EVENING?.split("-")
    //Tuesday
    const tuesdayMorningObj = slotsObj?.TUESDAY_MORNING?.split("-")
    const tuesdayAfternoonObj = slotsObj?.TUESDAY_AFTERNOON?.split("-")
    const tuesdayEveningObj = slotsObj?.TUESDAY_EVENING?.split("-")
    //Wednesday
    const wednesdayMorningObj = slotsObj?.WEDNESDAY_MORNING?.split("-")
    const wednesdayAfternoonObj = slotsObj?.WEDNESDAY_AFTERNOON?.split("-")
    const wednesdayEveningObj = slotsObj?.WEDNESDAY_EVENING?.split("-")
    //Thursday
    const thursdayMorningObj = slotsObj?.THURSDAY_MORNING?.split("-")
    const thursdayAfternoonObj = slotsObj?.THURSDAY_AFTERNOON?.split("-")
    const thursdayEveningObj = slotsObj?.THURSDAY_EVENING?.split("-")
    //Friday
    const fridayMorningObj = slotsObj?.FRIDAY_MORNING?.split("-")
    const fridayAfternoonObj = slotsObj?.FRIDAY_AFTERNOON?.split("-")
    const fridayEveningObj = slotsObj?.FRIDAY_EVENING?.split("-")
    //Saturday
    const saturdayMorningObj = slotsObj?.SATURDAY_MORNING?.split("-")
    const saturdayAfternoonObj = slotsObj?.SATURDAY_AFTERNOON?.split("-")
    const saturdayEveningObj = slotsObj?.SATURDAY_EVENING?.split("-")
    //Sunday
    const sundayMorningObj = slotsObj?.SUNDAY_MORNING?.split("-")
    const sundayAfternoonObj = slotsObj?.SUNDAY_AFTERNOON?.split("-")
    const sundayEveningObj = slotsObj?.SUNDAY_EVENING?.split("-")

    setAvailabilitySlots({
      Monday: {
        mondayMorningStartTime: mondayMorningObj ? mondayMorningObj?.[0] : "-",
        mondayMorningEndTime: mondayMorningObj ? mondayMorningObj?.[1] : "-",
        mondayAfternoonStartTime: mondayAfternoonObj ? mondayAfternoonObj?.[0] : "-",
        mondayAfternoonEndTime: mondayAfternoonObj ? mondayAfternoonObj?.[1] : "-",
        mondayEveningStartTime: mondayEveningObj ? mondayEveningObj?.[0] : "-",
        mondayEveningEndTime: mondayEveningObj ? mondayEveningObj?.[1] : "-",
      },
      Tuesday: {
        tuesdayMorningStartTime: tuesdayMorningObj ? tuesdayMorningObj?.[0] : "-",
        tuesdayMorningEndTime: tuesdayMorningObj ? tuesdayMorningObj?.[1] : "-",
        tuesdayAfternoonStartTime: tuesdayAfternoonObj ? tuesdayAfternoonObj?.[0] : "-",
        tuesdayAfternoonEndTime: tuesdayAfternoonObj ? tuesdayAfternoonObj?.[1] : "-",
        tuesdayEveningStartTime: tuesdayEveningObj ? tuesdayEveningObj?.[0] : "-",
        tuesdayEveningEndTime: tuesdayEveningObj ? tuesdayEveningObj?.[1] : "-",
      },
      Wednesday: {
        wednesdayMorningStartTime: wednesdayMorningObj ? wednesdayMorningObj?.[0] : "-",
        wednesdayMorningEndTime: wednesdayMorningObj ? wednesdayMorningObj?.[1] : "-",
        wednesdayAfternoonStartTime: wednesdayAfternoonObj ? wednesdayAfternoonObj?.[0] : "-",
        wednesdayAfternoonEndTime: wednesdayAfternoonObj ? wednesdayAfternoonObj?.[1] : "-",
        wednesdayEveningStartTime: wednesdayEveningObj ? wednesdayEveningObj?.[0] : "-",
        wednesdayEveningEndTime: wednesdayEveningObj ? wednesdayEveningObj?.[1] : "-",
      },
      Thursday: {
        thursdayMorningStartTime: thursdayMorningObj ? thursdayMorningObj?.[0] : "-",
        thursdayMorningEndTime: thursdayMorningObj ? thursdayMorningObj?.[1] : "-",
        thursdayAfternoonStartTime: thursdayAfternoonObj ? thursdayAfternoonObj?.[0] : "-",
        thursdayAfternoonEndTime: thursdayAfternoonObj ? thursdayAfternoonObj?.[1] : "-",
        thursdayEveningStartTime: thursdayEveningObj ? thursdayEveningObj?.[0] : "-",
        thursdayEveningEndTime: thursdayEveningObj ? thursdayEveningObj?.[1] : "-",
      },
      Friday: {
        fridayMorningStartTime: fridayMorningObj ? fridayMorningObj?.[0] : "-",
        fridayMorningEndTime: fridayMorningObj ? fridayMorningObj?.[1] : "-",
        fridayAfternoonStartTime: fridayAfternoonObj ? fridayAfternoonObj?.[0] : "-",
        fridayAfternoonEndTime: fridayAfternoonObj ? fridayAfternoonObj?.[1] : "-",
        fridayEveningStartTime: fridayEveningObj ? fridayEveningObj?.[0] : "-",
        fridayEveningEndTime: fridayEveningObj ? fridayEveningObj?.[1] : "-",
      },

      Saturday: {
        saturdayMorningStartTime: saturdayMorningObj ? saturdayMorningObj?.[0] : "-",
        saturdayMorningEndTime: saturdayMorningObj ? saturdayMorningObj?.[1] : "-",
        saturdayAfternoonStartTime: saturdayAfternoonObj ? saturdayAfternoonObj?.[0] : "-",
        saturdayAfternoonEndTime: saturdayAfternoonObj ? saturdayAfternoonObj?.[1] : "-",
        saturdayEveningStartTime: saturdayEveningObj ? saturdayEveningObj?.[0] : "-",
        saturdayEveningEndTime: saturdayEveningObj ? saturdayEveningObj?.[1] : "-",
      },

      Sunday: {
        sundayMorningStartTime: sundayMorningObj ? sundayMorningObj?.[0] : "-",
        sundayMorningEndTime: sundayMorningObj ? sundayMorningObj?.[1] : "-",
        sundayAfternoonStartTime: sundayAfternoonObj ? sundayAfternoonObj?.[0] : "-",
        sundayAfternoonEndTime: sundayAfternoonObj ? sundayAfternoonObj?.[1] : "-",
        sundayEveningStartTime: sundayEveningObj ? sundayEveningObj?.[0] : "-",
        sundayEveningEndTime: sundayEveningObj ? sundayEveningObj?.[1] : "-",
      },
    })
  }

  const handleHourChange = (event: any) => {
    setHours(event.target.value);
  };

  const handleMinuteChange = (event: any, eachDay: any, ele: any) => {
    const newSlots = { ...availabilitySlots };
    let a = newSlots[eachDay][ele];
    let b = a?.split(":");
    newSlots[eachDay][ele] = b?.[0] + ":" + event.target.value;
    setAvailabilitySlots(newSlots)
    setMinutes(event.target.value)
  };

  const handleAMPMChange = (event: any) => {
    setAMPM(event.target.value);
  };

  const getSlotDuration = () => {
    if (userRole === MocUserRole.CENTER_ADMIN) {
      const temp = allCenterDetails.find((c: any) => c?.id === userDetail?.currentCenter?.centerId)
      if (temp) {
        setSlotsRequired(temp?.slotDuration)
      }
    }
    else if (userRole === MocUserRole.SYSTEM_ADMIN) {
      const temp = allCenterDetails.find((label: any) => label?.id === selectedCenterDetails?.centerId)
      if (temp) {
        setSlotsRequired(temp?.slotDuration)
      }
    }
  }

  const generateMinuteOptions = () => {
    const options = [];
    for (let i = 0; i < 60; i += slotsRequired) {
      const minute = i.toString().padStart(2, '0');
      options.push(<option key={minute}>{minute}</option>);
    }
    return options;
  }

  const handleMarkAsDefault = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    const newSlots: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(defaultSlots)) {
      newSlots[key] = {};
      for (const [timeSlot, time] of Object.entries(value)) {
        if (time === "-:---:-"
        ) {
          newSlots[key][timeSlot] = null;
        } else {
          newSlots[key][timeSlot] = time;
        }
      }
    }
    setAvailabilitySlots(newSlots);
  };

  const handleClearAll = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    const newSlots: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(defaultSlots)) {
      newSlots[key] = {};
      for (const [timeSlot, time] of Object.entries(value)) {
        newSlots[key][timeSlot] = "--:--";
      }
    }
    setAvailabilitySlots(newSlots);
  };

  const handleAvailability = () => {
    let startDateInfo = ""
    let endDateInfo = ""
    if (absenseListInfo?.absenseFromDate && absenseListInfo?.absenseFromTime) {
      startDateInfo = `${absenseListInfo?.absenseFromDate}T${absenseListInfo?.absenseFromTime}`
    }
    if (absenseListInfo?.absenseToDate && absenseListInfo?.absenseToTime) {
      endDateInfo = `${absenseListInfo?.absenseToDate}T${absenseListInfo?.absenseToTime}`
    }
    let avSlot = `${absenseListInfo.fromTime}-${absenseListInfo.toTime}`

    let error: any = ""

    const availabilityDays: any = Object.keys(availabilitySlots)
    for (const day of availabilityDays) {
      const slotsList: any = Object.keys(availabilitySlots[day])
      //Keys
      const morningStartKey: any = slotsList?.find((each: any) => each?.includes("MorningStartTime"))
      const morningEndKey: any = slotsList?.find((each: any) => each?.includes("MorningEndTime"))
      const afternoonStartKey: any = slotsList?.find((each: any) => each?.includes("AfternoonStartTime"))
      const afternoonEndKey: any = slotsList?.find((each: any) => each?.includes("AfternoonEndTime"))
      const eveningStartKey: any = slotsList?.find((each: any) => each?.includes("EveningStartTime"))
      const eveningEndKey: any = slotsList?.find((each: any) => each?.includes("EveningEndTime"))
      //Values
      const morningStartValue: any = availabilitySlots[day][morningStartKey]
      const morningEndValue: any = availabilitySlots[day][morningEndKey]
      const afternoonStartValue: any = availabilitySlots[day][afternoonStartKey]
      const afternoonEndValue: any = availabilitySlots[day][afternoonEndKey]
      const eveningStartValue: any = availabilitySlots[day][eveningStartKey]
      const eveningEndValue: any = availabilitySlots[day][eveningEndKey]

      //Morning Slots Valdiation
      if (
        (
          morningStartValue?.includes("--:--") || morningStartValue?.includes("-:-")
        )
        && !(
          morningEndValue?.includes("--:--") || morningEndValue?.includes("-:-")
        )
      ) {
        error = `Please Select ${day} Morning Start Time`
        break;
      } else if (
        !(
          morningStartValue?.includes("--:--") || morningStartValue?.includes("-:-")
        )
        && (
          morningEndValue?.includes("--:--") || morningEndValue?.includes("-:-")
        )
      ) {
        error = `Please Select ${day} Morning End Time`
        break;
      }
      //Afternoon Slots Valdiation
      if (
        (
          afternoonStartValue?.includes("--:--") || afternoonStartValue?.includes("-:-")
        )
        && !(
          afternoonEndValue?.includes("--:--") || afternoonEndValue?.includes("-:-")
        )
      ) {
        error = `Please Select ${day} Afternoon Start Time`
        break;
      } else if (
        !(
          afternoonStartValue?.includes("--:--") || afternoonStartValue?.includes("-:-")
        )
        && (
          afternoonEndValue?.includes("--:--") || afternoonEndValue?.includes("-:-")
        )
      ) {
        error = `Please Select ${day} Afternoon End Time`
        break;
      }
      //Evening Slots Valdiation
      if (
        (
          eveningStartValue?.includes("--:--") || eveningStartValue?.includes("-:-")
        )
        && !(
          eveningEndValue?.includes("--:--") || eveningEndValue?.includes("-:-")
        )
      ) {
        error = `Please Select ${day} Evening Start Time`
        break;
      } else if (
        !(
          eveningStartValue?.includes("--:--") || eveningStartValue?.includes("-:-")
        )
        && (
          eveningEndValue?.includes("--:--") || eveningEndValue?.includes("-:-")
        )
      ) {
        error = `Please Select ${day} Evening End Time`
        break;
      }

      if (!error) {
        for (const eachSlot of slotsList) {
          const slotTimeValue: any = availabilitySlots[day][eachSlot]
          const splitTimeSlot: any = slotTimeValue?.split(":")
          if (splitTimeSlot?.length > 1) {
            if (
              (
                splitTimeSlot[0] === "00" || splitTimeSlot[0]?.includes("--") || splitTimeSlot[0]?.includes("-")
              ) && splitTimeSlot[1] === ("00")
            ) {
              error = `Please select the hour value for ${defaultSlotDescriptions[eachSlot]}`
              break;
            } else if (
              !(["-", "--"]?.includes(splitTimeSlot[0]))
              && (
                splitTimeSlot[1]?.includes("--") || splitTimeSlot[1]?.includes("-")
              )
            ) {
              error = `Please select the minutes value for ${defaultSlotDescriptions[eachSlot]}`
              break;
            }
          }
        }
      }
    }

    if (error) {
      setMessage(error)
      setToastType("error")
      setSuccess(true)
      return;
    }
    const result: any = {
      MONDAY_MORNING:
        availabilitySlots?.Monday?.mondayMorningStartTime?.includes("--:--") ||
          availabilitySlots?.Monday?.mondayMorningStartTime?.includes("-:-") ||
          availabilitySlots?.Monday?.mondayMorningStartTime?.includes("-") || availabilitySlots?.Monday?.mondayMorningEndTime?.includes("--:--") || availabilitySlots?.Monday?.mondayMorningEndTime?.includes("-:-") || availabilitySlots?.Monday?.mondayMorningEndTime?.includes("-") ? null : `${availabilitySlots?.Monday?.mondayMorningStartTime}-${availabilitySlots?.Monday?.mondayMorningEndTime}`,

      MONDAY_AFTERNOON:
        availabilitySlots?.Monday?.mondayAfternoonStartTime?.includes("--:--") ||
          availabilitySlots?.Monday?.mondayAfternoonStartTime?.includes("-:-") ||
          availabilitySlots?.Monday?.mondayAfternoonStartTime?.includes("-") ||
          availabilitySlots?.Monday?.mondayAfternoonEndTime?.includes("--:--") ||
          availabilitySlots?.Monday?.mondayAfternoonEndTime?.includes("-:-") ||
          availabilitySlots?.Monday?.mondayAfternoonEndTime?.includes("-") ? null : `${availabilitySlots?.Monday?.mondayAfternoonStartTime}-${availabilitySlots?.Monday?.mondayAfternoonEndTime}`,

      MONDAY_EVENING:
        availabilitySlots?.Monday?.mondayEveningStartTime?.includes("--:--") || availabilitySlots?.Monday?.mondayEveningStartTime?.includes("-:-") || availabilitySlots?.Monday?.mondayEveningStartTime?.includes("-") || availabilitySlots?.Monday?.mondayEveningEndTime?.includes("--:--") || availabilitySlots?.Monday?.mondayEveningEndTime?.includes("-:-") || availabilitySlots?.Monday?.mondayEveningEndTime?.includes("-") ? null : `${availabilitySlots?.Monday?.mondayEveningStartTime}-${availabilitySlots?.Monday?.mondayEveningEndTime}`,

      TUESDAY_MORNING:
        availabilitySlots?.Tuesday?.tuesdayMorningStartTime?.includes("--:--") ||
          availabilitySlots?.Tuesday?.tuesdayMorningStartTime?.includes("-:-") ||
          availabilitySlots?.Tuesday?.tuesdayMorningStartTime?.includes("-") || availabilitySlots?.Tuesday?.tuesdayMorningEndTime?.includes("--:--") ||
          availabilitySlots?.Tuesday?.tuesdayMorningEndTime?.includes("-:-") || availabilitySlots?.Tuesday?.tuesdayMorningEndTime?.includes("-") ? null : `${availabilitySlots?.Tuesday?.tuesdayMorningStartTime}-${availabilitySlots?.Tuesday?.tuesdayMorningEndTime}`,

      TUESDAY_AFTERNOON:
        availabilitySlots?.Tuesday?.tuesdayAfternoonStartTime?.includes("--:--") ||
          availabilitySlots?.Tuesday?.tuesdayAfternoonStartTime?.includes("-:-") ||
          availabilitySlots?.Tuesday?.tuesdayAfternoonStartTime?.includes("-") ||
          availabilitySlots?.Tuesday?.tuesdayAfternoonEndTime?.includes("--:--") ||
          availabilitySlots?.Tuesday?.tuesdayAfternoonEndTime?.includes("-:-") ||
          availabilitySlots?.Tuesday?.tuesdayAfternoonEndTime?.includes("-") ? null : `${availabilitySlots?.Tuesday?.tuesdayAfternoonStartTime}-${availabilitySlots?.Tuesday?.tuesdayAfternoonEndTime}`,

      TUESDAY_EVENING:
        availabilitySlots?.Tuesday?.tuesdayEveningStartTime?.includes("--:--") ||
          availabilitySlots?.Tuesday?.tuesdayEveningStartTime?.includes("-:-") ||
          availabilitySlots?.Tuesday?.tuesdayEveningStartTime?.includes("-") ||
          availabilitySlots?.Tuesday?.tuesdayEveningEndTime?.includes("--:--") ||
          availabilitySlots?.Tuesday?.tuesdayEveningEndTime?.includes("-:-") || availabilitySlots?.Tuesday?.tuesdayEveningEndTime?.includes("-") ? null : `${availabilitySlots?.Tuesday?.tuesdayEveningStartTime}-${availabilitySlots?.Tuesday?.tuesdayEveningEndTime}`,

      WEDNESDAY_MORNING:
        availabilitySlots?.Wednesday?.wednesdayMorningStartTime?.includes("--:--") ||
          availabilitySlots?.Wednesday?.wednesdayMorningStartTime?.includes("-:-") ||
          availabilitySlots?.Wednesday?.wednesdayMorningStartTime?.includes("-") ||
          availabilitySlots?.Wednesday?.wednesdayMorningEndTime?.includes("--:--") ||
          availabilitySlots?.Wednesday?.wednesdayMorningEndTime?.includes("-:-") ||
          availabilitySlots?.Wednesday?.wednesdayMorningEndTime?.includes("-") ? null : `${availabilitySlots?.Wednesday?.wednesdayMorningStartTime}-${availabilitySlots?.Wednesday?.wednesdayMorningEndTime}`,

      WEDNESDAY_AFTERNOON:
        availabilitySlots?.Wednesday?.wednesdayAfternoonStartTime?.includes("--:--") ||
          availabilitySlots?.Wednesday?.wednesdayAfternoonStartTime?.includes("-:-") ||
          availabilitySlots?.Wednesday?.wednesdayAfternoonStartTime?.includes("-") ||
          availabilitySlots?.Wednesday?.wednesdayAfternoonEndTime?.includes("--:--") ||
          availabilitySlots?.Wednesday?.wednesdayAfternoonEndTime?.includes("-:-") ||
          availabilitySlots?.Wednesday?.wednesdayAfternoonEndTime?.includes("-") ? null : `${availabilitySlots?.Wednesday?.wednesdayAfternoonStartTime}-${availabilitySlots?.Wednesday?.wednesdayAfternoonEndTime}`,

      WEDNESDAY_EVENING:
        availabilitySlots?.Wednesday?.wednesdayEveningStartTime?.includes("--:--") ||
          availabilitySlots?.Wednesday?.wednesdayEveningStartTime?.includes("-:-") ||
          availabilitySlots?.Wednesday?.wednesdayEveningStartTime?.includes("-") ||
          availabilitySlots?.Wednesday?.wednesdayEveningEndTime?.includes("--:--") ||
          availabilitySlots?.Wednesday?.wednesdayEveningEndTime?.includes("-:-") ||
          availabilitySlots?.Wednesday?.wednesdayEveningEndTime?.includes("-") ? null : `${availabilitySlots?.Wednesday?.wednesdayEveningStartTime}-${availabilitySlots?.Wednesday?.wednesdayEveningEndTime}`,

      THURSDAY_MORNING:
        availabilitySlots?.Thursday?.thursdayMorningStartTime?.includes("--:--") ||
          availabilitySlots?.Thursday?.thursdayMorningStartTime?.includes("-:-") ||
          availabilitySlots?.Thursday?.thursdayMorningStartTime?.includes("-") ||
          availabilitySlots?.Thursday?.thursdayMorningEndTime?.includes("--:--") ||
          availabilitySlots?.Thursday?.thursdayMorningEndTime?.includes("-:-") ||
          availabilitySlots?.Thursday?.thursdayMorningEndTime?.includes("-") ? null : `${availabilitySlots?.Thursday?.thursdayMorningStartTime}-${availabilitySlots?.Thursday?.thursdayMorningEndTime}`,

      THURSDAY_AFTERNOON:
        availabilitySlots?.Thursday?.thursdayAfternoonStartTime?.includes("--:--") ||
          availabilitySlots?.Thursday?.thursdayAfternoonStartTime?.includes("-:-") ||
          availabilitySlots?.Thursday?.thursdayAfternoonStartTime?.includes("-") ||
          availabilitySlots?.Thursday?.thursdayAfternoonEndTime?.includes("--:--") ||
          availabilitySlots?.Thursday?.thursdayAfternoonEndTime?.includes("-:-") ||
          availabilitySlots?.Thursday?.thursdayAfternoonEndTime?.includes("-") ? null : `${availabilitySlots?.Thursday?.thursdayAfternoonStartTime}-${availabilitySlots?.Thursday?.thursdayAfternoonEndTime}`,

      THURSDAY_EVENING:
        availabilitySlots?.Thursday?.thursdayEveningStartTime?.includes("--:--") ||
          availabilitySlots?.Thursday?.thursdayEveningStartTime?.includes("-:-") ||
          availabilitySlots?.Thursday?.thursdayEveningStartTime?.includes("-") ||
          availabilitySlots?.Thursday?.thursdayEveningEndTime?.includes("--:--") ||
          availabilitySlots?.Thursday?.thursdayEveningEndTime?.includes("-:-") ||
          availabilitySlots?.Thursday?.thursdayEveningEndTime?.includes("-") ? null : `${availabilitySlots?.Thursday?.thursdayEveningStartTime}-${availabilitySlots?.Thursday?.thursdayEveningEndTime}`,

      FRIDAY_MORNING:
        availabilitySlots?.Friday?.fridayMorningStartTime?.includes("--:--") || availabilitySlots?.Friday?.fridayMorningStartTime?.includes("-:-") || availabilitySlots?.Friday?.fridayMorningStartTime?.includes("-") || availabilitySlots?.Friday?.fridayMorningEndTime?.includes("--:--") || availabilitySlots?.Friday?.fridayMorningEndTime?.includes("-:-") || availabilitySlots?.Friday?.fridayMorningEndTime?.includes("-") ? null : `${availabilitySlots?.Friday?.fridayMorningStartTime}-${availabilitySlots?.Friday?.fridayMorningEndTime}`,

      FRIDAY_AFTERNOON:
        availabilitySlots?.Friday?.fridayAfternoonStartTime?.includes("--:--") ||
          availabilitySlots?.Friday?.fridayAfternoonStartTime?.includes("-:-") ||
          availabilitySlots?.Friday?.fridayAfternoonStartTime?.includes("-") ||
          availabilitySlots?.Friday?.fridayAfternoonEndTime?.includes("--:--") ||
          availabilitySlots?.Friday?.fridayAfternoonEndTime?.includes("-:-") || availabilitySlots?.Friday?.fridayAfternoonEndTime?.includes("-") ? null : `${availabilitySlots?.Friday?.fridayAfternoonStartTime}-${availabilitySlots?.Friday?.fridayAfternoonEndTime}`,

      FRIDAY_EVENING:
        availabilitySlots?.Friday?.fridayEveningStartTime?.includes("--:--") || availabilitySlots?.Friday?.fridayEveningStartTime?.includes("-:-") || availabilitySlots?.Friday?.fridayEveningStartTime?.includes("-") || availabilitySlots?.Friday?.fridayEveningEndTime?.includes("--:--") || availabilitySlots?.Friday?.fridayEveningEndTime?.includes("-:-") || availabilitySlots?.Friday?.fridayEveningEndTime?.includes("-") ? null : `${availabilitySlots?.Friday?.fridayEveningStartTime}-${availabilitySlots?.Friday?.fridayEveningEndTime}`,

      SATURDAY_MORNING:
        availabilitySlots?.Saturday?.saturdayMorningStartTime?.includes("--:--") ||
          availabilitySlots?.Saturday?.saturdayMorningStartTime?.includes("-:-") ||
          availabilitySlots?.Saturday?.saturdayMorningStartTime?.includes("-") ||
          availabilitySlots?.Saturday?.saturdayMorningEndTime?.includes("--:--") ||
          availabilitySlots?.Saturday?.saturdayMorningEndTime?.includes("-:-") ||
          availabilitySlots?.Saturday?.saturdayMorningEndTime?.includes("-") ? null : `${availabilitySlots?.Saturday?.saturdayMorningStartTime}-${availabilitySlots?.Saturday?.saturdayMorningEndTime}`,

      SATURDAY_AFTERNOON:
        availabilitySlots?.Saturday?.saturdayAfternoonStartTime?.includes("--:--") ||
          availabilitySlots?.Saturday?.saturdayAfternoonStartTime?.includes("-:-") ||
          availabilitySlots?.Saturday?.saturdayAfternoonStartTime?.includes("-") ||
          availabilitySlots?.Saturday?.saturdayAfternoonEndTime?.includes("--:--") ||
          availabilitySlots?.Saturday?.saturdayAfternoonEndTime?.includes("-:-") ||
          availabilitySlots?.Saturday?.saturdayAfternoonEndTime?.includes("-") ? null : `${availabilitySlots?.Saturday?.saturdayAfternoonStartTime}-${availabilitySlots?.Saturday?.saturdayAfternoonEndTime}`,

      SATURDAY_EVENING:
        availabilitySlots?.Saturday?.saturdayEveningStartTime?.includes("--:--") ||
          availabilitySlots?.Saturday?.saturdayEveningStartTime?.includes("-:-") ||
          availabilitySlots?.Saturday?.saturdayEveningStartTime?.includes("-") ||
          availabilitySlots?.Saturday?.saturdayEveningEndTime?.includes("--:--") ||
          availabilitySlots?.Saturday?.saturdayEveningEndTime?.includes("-:-") ||
          availabilitySlots?.Saturday?.saturdayEveningEndTime?.includes("-") ? null : `${availabilitySlots?.Saturday?.saturdayEveningStartTime}-${availabilitySlots?.Saturday?.saturdayEveningEndTime}`,

      SUNDAY_MORNING:
        availabilitySlots?.Sunday?.sundayMorningStartTime?.includes("--:--") || availabilitySlots?.Sunday?.sundayMorningStartTime?.includes("-:-") || availabilitySlots?.Sunday?.sundayMorningStartTime?.includes("-") || availabilitySlots?.Sunday?.sundayMorningEndTime?.includes("--:--") || availabilitySlots?.Sunday?.sundayMorningEndTime?.includes("-:-") || availabilitySlots?.Sunday?.sundayMorningEndTime?.includes("-") ? null : `${availabilitySlots?.Sunday?.sundayMorningStartTime}-${availabilitySlots?.Sunday?.sundayMorningEndTime}`,

      SUNDAY_AFTERNOON:
        availabilitySlots?.Sunday?.sundayAfternoonStartTime?.includes("--:--") ||
          availabilitySlots?.Sunday?.sundayAfternoonStartTime?.includes("-:-") ||
          availabilitySlots?.Sunday?.sundayAfternoonStartTime?.includes("-") ||
          availabilitySlots?.Sunday?.sundayAfternoonEndTime?.includes("--:--") ||
          availabilitySlots?.Sunday?.sundayAfternoonEndTime?.includes("-:-") || availabilitySlots?.Sunday?.sundayAfternoonEndTime?.includes("-") ? null : `${availabilitySlots?.Sunday?.sundayAfternoonStartTime}-${availabilitySlots?.Sunday?.sundayAfternoonEndTime}`,

      SUNDAY_EVENING:
        availabilitySlots?.Sunday?.sundayEveningStartTime?.includes("--:--") || availabilitySlots?.Sunday?.sundayEveningStartTime?.includes("-:-") || availabilitySlots?.Sunday?.sundayEveningStartTime?.includes("-") || availabilitySlots?.Sunday?.sundayEveningEndTime?.includes("--:--") || availabilitySlots?.Sunday?.sundayEveningEndTime?.includes("-:-") || availabilitySlots?.Sunday?.sundayEveningEndTime?.includes("-") ? null : `${availabilitySlots?.Sunday?.sundayEveningStartTime}-${availabilitySlots?.Sunday?.sundayEveningEndTime}`,
    }

    let unavailabilityObj = [...newAbsenseListInfo]

    // const combinedList = { ...absenseListInfo, ...newAbsenseListInfo }
    // console.log(combinedList, "combined List");
    // if (startDateInfo && endDateInfo && absenseListInfo?.remarks) {
    //   unavailabilityObj.push({
    //     reason: absenseListInfo?.remarks,
    //     start: startDateInfo,
    //     end: endDateInfo,
    //   })
    // }


    // unavailabilityObj.push({
    //   reason: absenseListInfo?.remarks,
    //   start: startDateInfo,
    //   end: endDateInfo,
    // })







    if (
      startDateInfo &&
      endDateInfo
    ) {
      unavailabilityObj.push({
        reason: absenseListInfo?.remarks,
        start: startDateInfo,
        end: endDateInfo,
      });
    }


    if (!unavailabilityObj || unavailabilityObj.length === 0) {
      unavailabilityObj = [];
    }


    let availabilityRequest: any = {
      consultantId: staffDetails?.id,
      availabilityTimeFrame: result,
      unavailability: unavailabilityObj,
    }

    if (userRole === MocUserRole.SYSTEM_ADMIN) {
      availabilityRequest["centerId"] = selectedCenterDetails.id
      availabilityRequest["centerName"] = selectedCenterDetails?.centerName

    } else {
      availabilityRequest["centerId"] = userDetail?.currentCenter?.centerId
      availabilityRequest["centerName"] = userDetail?.currentCenter?.centerName
    }

    if (!avaialbilityResult?.id) {
      addNewAvailability(availabilityRequest)
        .then((res: any) => {
          setIsLoading(false)
          setMessage("Availability details added successfully")
          setToastType("success")
          setSuccess(true)

        })
        .catch((err: any) => {
          setIsLoading(false)
          setMessage(err?.response?.data?.message)
          setSuccess(true)
          setToastType("error")
        })
    } else {
      availabilityRequest["id"] = avaialbilityResult?.id
      updateAvailability(availabilityRequest)
        .then((res: any) => {
          setIsLoading(false)
          toggleDisplayToast({
            text: "Availability Details have been updated successfully",
            type: "success",
          })
          // setMessage("Availability details updated successfully")
          // setToastType("success")
          // setSuccess(true)
          setAbsenseListInfo({
            fromTime: "",
            toTime: "",
            absenseFromDate: "",
            absenseFromTime: "",
            absenseToDate: "",
            absenseToTime: "",
            remarks: "",
          })
          fetchAvailabilityDetails()

        })
        .catch((err: any) => {
          console.log(err, "error")
          setIsLoading(false)
          setMessage(err?.response?.data?.message)
          setSuccess(true)
          setToastType("error")
        })
    }
  }

  const handleRowClear = (e: any, day: any) => {
    e.preventDefault();
    e.stopPropagation();

    const newSlots: { [key: string]: any } = { ...availabilitySlots };
    for (const [key, value] of Object.entries(defaultSlots)) {
      if (key === day) {
        newSlots[key] = {};
        for (const [timeSlot, time] of Object.entries(value)) {
          newSlots[key][timeSlot] = "--:--";
        }
      }
    }
    setAvailabilitySlots(newSlots);
  }

  const isDateBeforeToday = (selectedDate: string | number | Date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set current time to the beginning of the day
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0); // Set selected time to the beginning of the day

    return selected < today;
  };

  function isDateBeforeFrom(date1: string | number | Date, date2: string | number | Date) {
    const parsedDate1 = new Date(date1);
    const parsedDate2 = new Date(date2);

    // Use getTime() to compare in milliseconds
    return parsedDate1.getTime() < parsedDate2.getTime();
  }

  return (
    <div className="edit-manage-staff-wrapper">
      {
        success ? (
          <Toast
            textMessage={message}
            onCloseText={"Close"}
            onClose={() => {
              setSuccess(false)
            }}
            type={toastType}
          ></Toast>
        ) : isLoading ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        ) : displayToast ? (
          <Toast
            textMessage={displayToast?.text}
            type={displayToast?.type}
            onClose={() => {
              if (displayToast?.onCloseUnavailability) {
                handleAvailability()
              }
              else {
                toggleDisplayToast(false)
              }
            }}
            onCloseText="Close"
            onClickText={null}
          />
        ) : null
      }
      <div
        className="approval-back-image"
        onClick={() => {
          history.push({
            pathname: "/editManageStaff",
            state: { idValue: id },
          })
        }}
      >
        <img
          src={"../../../assets/images/back-icon.svg"}
          height={"60px"}
          width={"60px"}
          alt="back button"
          className="back_button"
        />
        <div className="edit-manage-staff-heading">Staff Details</div>
      </div>
      <div className="edit-details-wrapper">
        <div className="edit-details-container">
          <div className="manage-staff-details">
            {/* Location Select */}
            <div className="col-md-4 col-lg-4 staff_details">
              <div>
                <label className="textlabel">Location : </label>
              </div>
              <Dropdown
                selected={selectedCenterDetails?.centerName}
                placeholder="Select Center"
                options={staffCenterOptions}
                updateDropdown={(option: any) => {
                  const centerObj = allCenterDetails?.find((c: any) => c?.centerName === option)
                  if (centerObj) {
                    setSelectedCenterDetails(centerObj)
                  }
                }}
                disable={readOnly || userRole === MocUserRole?.CENTER_ADMIN}
              />
            </div>
            {/* Mark Availability Buttons */}
            <div className="col-md-12 col-lg-12 staff_details">
              <div className="availability-button me-2">
                {(allowed.includes("CONSULTANT") ||
                  allowed.includes("HOME_CARE_NURSE") ||
                  allowed.includes("HOME_CARE_RMO") ||
                  allowed.includes("HOME_CARE_NURSE") ||
                  allowed.includes("GENETIC_COUNSELLOR") ||
                  allowed.includes("PSYCHOLOGIST") ||
                  allowed.includes("PHYSIOTHERAPIST") ||
                  allowed.includes("NUTRITIONIST")) && (
                    <Button
                      text="Mark default timings"
                      onClick={handleMarkAsDefault}
                      id="mark-default-timings"
                      disabled={readOnly || !selectedCenterDetails?.id}
                    />
                  )}
                <div className="ms-2">
                  {(allowed.includes("CONSULTANT") ||
                    allowed.includes("HOME_CARE_NURSE") ||
                    allowed.includes("HOME_CARE_RMO") ||
                    allowed.includes("HOME_CARE_NURSE") ||
                    allowed.includes("GENETIC_COUNSELLOR") ||
                    allowed.includes("PSYCHOLOGIST") ||
                    allowed.includes("PHYSIOTHERAPIST") ||
                    allowed.includes("NUTRITIONIST")) && (
                      <Button
                        text="Clear All"
                        disabled={readOnly || !selectedCenterDetails?.id}
                        onClick={handleClearAll}
                        id="mark-default-timings"
                      />
                    )}
                </div>
              </div>
              {/* Set Availability */}
              {(allowed.includes("CONSULTANT") ||
                allowed.includes("HOME_CARE_NURSE") ||
                allowed.includes("HOME_CARE_RMO") ||
                allowed.includes("HOME_CARE_NURSE") ||
                allowed.includes("GENETIC_COUNSELLOR") ||
                allowed.includes("PSYCHOLOGIST") ||
                allowed.includes("PHYSIOTHERAPIST") ||
                allowed.includes("NUTRITIONIST")) && (
                  <>
                    <div className="availability-timings">
                      <div className="row">
                        <div className="col-2 textlabel">Availability timings:</div>
                        <div className="col-8 slot-duration">
                          {slotDuration?.map((eachTime: any) => (
                            <div>{eachTime}</div>
                          ))}
                        </div>
                      </div>
                      {Object.keys(availabilitySlots)?.map((eachDay: any) => {
                        return (
                          <div>
                            <div className="row section">
                              <div className="col-2 textlabel">{eachDay}</div>
                              <div className="col-8 slot-timings">
                                <div className="row">
                                  {Object.keys(availabilitySlots[eachDay]).map((ele: any) => {
                                    const selectedTime = availabilitySlots[eachDay][ele];
                                    const [selectedHour, selectedMinute] = selectedTime ? selectedTime.split(":") : [null, null];
                                    const showHyphen = selectedHour === null && selectedMinute === null;
                                    return (
                                      <div className="col-2">
                                        <div className="time-picker-container">
                                          <input
                                            type="text"
                                            className="time-pickable"
                                            onChange={(event) => {
                                              const newSlots = { ...availabilitySlots };
                                              newSlots[eachDay][ele] = event.target.value || "";
                                              setAvailabilitySlots(newSlots);
                                            }}
                                            disabled={!selectedCenterDetails?.id
                                            }
                                          />
                                          <div className="time_selector">
                                            {showHyphen ? (
                                              selectedCenterDetails?.id && <span>-</span>
                                            ) : (
                                              <>
                                                <select
                                                  value={selectedHour !== null && selectedHour !== "-" ? moment(selectedTime, "HH:mm").format("HH") : "-"}
                                                  onChange={(event) => {
                                                    const newSlots = { ...availabilitySlots };
                                                    const newHour = event.target.value;
                                                    let updatedTime: any = ""
                                                    if (newHour !== "") {
                                                      updatedTime += `${newHour}:`
                                                    }
                                                    if (newHour === "-") {
                                                      updatedTime += "--"
                                                    } else {
                                                      updatedTime += selectedMinute
                                                    }
                                                    newSlots[eachDay][ele] = newHour !== "" ?
                                                      updatedTime
                                                      : "-";
                                                    setAvailabilitySlots(newSlots);
                                                  }}
                                                  className="time_selector_select"
                                                >
                                                  <option value="-">--</option>
                                                  {[...Array(24).keys()].map((hour) => (
                                                    <option key={hour}>{hour.toString().padStart(2, "0")}</option>
                                                  ))}
                                                </select>
                                                :
                                                <select
                                                  value={selectedMinute !== null ? selectedMinute : "--"}
                                                  onChange={(event: any) => {
                                                    handleMinuteChange(event, eachDay, ele);
                                                    const newSlots = { ...availabilitySlots };
                                                    const newMinute = event.target.value === "--" ? "--" : event.target.value;
                                                    newSlots[eachDay][ele] = selectedHour !== null ? selectedHour + ":" + newMinute : "";
                                                    setAvailabilitySlots(newSlots);
                                                  }}
                                                  className="time_selector_hours"
                                                >
                                                  <option value="--">--</option>
                                                  {generateMinuteOptions()}
                                                </select>
                                                <select value={ampm} onChange={handleAMPMChange} className="time_selector_meridium">
                                                </select>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                              <div className="col-1 d-flex align-center ms-2">
                                <Button
                                  text="Clear"
                                  disabled={readOnly || !selectedCenterDetails?.id}
                                  onClick={(e: any) => handleRowClear(e, eachDay)}
                                  id="clear-row-timings"
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="absense-list-container">
                      <div className="row">
                        <div className="col-2 absense-list">Set Unavailability</div>

                        <div className="col-3">
                          <label>From Date</label>
                          <InputField
                            calendar={true}
                            value={absenseListInfo.absenseFromDate}
                            placeholder={"DD - MM - YYYY"}
                            handleChange={(e) => {
                              const selectedDate = e.target.value;
                              if (isDateBeforeToday(selectedDate)) {
                                toggleDisplayToast({
                                  text: "Selected date cannot be before today",
                                  type: "error",
                                })
                                return;
                              }

                              if (absenseListInfo.absenseToDate && isDateBeforeFrom(absenseListInfo.absenseToDate, selectedDate)) {
                                toggleDisplayToast({
                                  text: "To date cannot be smaller than From date",
                                  type: "error",
                                });
                                return;
                              }
                              setAbsenseListInfo({
                                ...absenseListInfo,
                                absenseFromDate: selectedDate,
                              });
                            }}
                            readOnly={!selectedCenterDetails?.id}
                          />
                        </div>
                        <div className="col-3">
                          <label>From Time</label>
                          <InputField
                            className="col-md-8 time-picker"
                            placeholder="From time"
                            value={absenseListInfo?.absenseFromTime}
                            type="time"
                            handleChange={(e) => {
                              console.log(e.target.value, "From Time");
                              setAbsenseListInfo({
                                ...absenseListInfo,
                                absenseFromTime: e.target.value,
                              })

                            }}
                            readOnly={!selectedCenterDetails?.id}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-2"></div>
                        <div className="col-3">
                          <label>To Date</label>
                          <InputField
                            calendar={true}
                            value={absenseListInfo.absenseToDate}
                            placeholder={"DD - MM - YYYY"}
                            handleChange={(e) => {

                              const selectedDate = e.target.value;
                              if (isDateBeforeToday(selectedDate)) {
                                toggleDisplayToast({
                                  text: "Selected date cannot be before today",
                                  type: "error",
                                })
                                return;
                              }

                              if (isDateBeforeFrom(selectedDate, absenseListInfo.absenseFromDate)) {
                                toggleDisplayToast({
                                  text: "To date cannot be smaller than From date",
                                  type: "error",
                                });
                                return;
                              }
                              setAbsenseListInfo({
                                ...absenseListInfo,
                                absenseToDate: selectedDate,
                              });

                            }}
                            readOnly={!selectedCenterDetails?.id}
                          />
                        </div>
                        <div className="col-3">
                          <label>To Time</label>
                          <InputField
                            className="col-md-8 time-picker"
                            placeholder="To time"
                            value={absenseListInfo?.absenseToTime}
                            type="time"
                            handleChange={(e) => {
                              setAbsenseListInfo({
                                ...absenseListInfo,
                                absenseToTime: e.target.value,
                              })
                            }}
                            readOnly={!selectedCenterDetails?.id}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-2"></div>
                        <div className="col-6 remarks-secion">
                          <InputField
                            placeholder="Remarks"
                            value={absenseListInfo?.remarks}
                            handleChange={(e) =>
                              setAbsenseListInfo({
                                ...absenseListInfo,
                                remarks: e.target.value,
                              })
                            }
                            readOnly={!selectedCenterDetails?.id}
                          />


                        </div>

                      </div>

                    </div>
                  </>
                )}
            </div>
          </div>
          {/* Page Actions */}
          <div className="button-alignment">
            <div>
              <Button
                text="Cancel"
                type={"button"}
                outline={true}
                disabled={readOnly}
                onClick={() => history.push({
                  pathname: "/editManageStaff",
                  state: { idValue: id },
                })}
                id="cancel"
              />
            </div>
            <div>
              <Button
                text={avaialbilityResult?.id ? "Update" : "Save"}
                type="submit"
                disabled={!selectedCenterDetails?.id}
                onClick={() => {
                  if (
                    (absenseListInfo.absenseFromDate && !absenseListInfo.absenseFromTime) ||
                    (!absenseListInfo.absenseFromDate && absenseListInfo.absenseFromTime) ||
                    (absenseListInfo.absenseToDate && !absenseListInfo.absenseToTime) ||
                    (!absenseListInfo.absenseToDate && absenseListInfo.absenseToTime)
                  ) {
                    toggleDisplayToast({
                      text: "Please select \"From Date\", \"From Time\", \"To Date\" and \"To Time\" to set the unavailability",
                      type: "error",
                    });
                    return;
                  }
                  else {
                    handleAvailability()
                  }
                }}
                id="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
